import { render, staticRenderFns } from "./UserPaymentTypeComponent.vue?vue&type=template&id=3d1bcea6"
import script from "./UserPaymentTypeComponent.vue?vue&type=script&lang=js"
export * from "./UserPaymentTypeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports